import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatClassName, dataAttribsForEl } from '../Util';
import Collapse from 'react-bootstrap/lib/Collapse';
import Icon from './Icon';

const ExpandableContent = props => {
  const {
    children,
    className,
    data,
    dataAttributes,
    onExpandedToggle,
    title, 
    titleSize
  } = props;

  const [expanded, setExpanded] = useState(props.expanded);

  useEffect(() => {
    setExpanded(props.expanded);
  }, [props.expanded]);

  useEffect(() => {
    if (typeof onExpandedToggle === 'function') {
      onExpandedToggle(expanded);
    }
  }, [expanded]);

  const getClasses = () => formatClassName([
    'expandable-content-title',
    `expandable-content-title-${titleSize}`,
    className
  ]);

  const toggleDataAttributes = dataAttribsForEl(data, dataAttributes);

  return (
    <div className="expandable-content">
      <div className={getClasses()} onClick={() => setExpanded(!expanded)} {...toggleDataAttributes}>
        <h4>{title}</h4>
        <Icon
          iconType={expanded ? 'chevron-down' : 'chevron-right'}
          additionalClasses="card-chevron"
        />
      </div>
      <Collapse in={expanded}>{children}</Collapse>
    </div>
    
  );
};

ExpandableContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  dataAttributes: PropTypes.object,
  expanded: PropTypes.bool,
  onExpandedToggle: PropTypes.func,
  title: PropTypes.string,
  titleSize: PropTypes.oneOf(["small", "medium", "large"])
};

ExpandableContent.defaultProps = {
  expanded: false,
  titleSize: "medium"
};

export default ExpandableContent;
